import Vue from 'vue'
import Vuex from 'vuex'

import getters from './getters'
import actions from './actions'
import mutations from './mutations'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		apiUrl: "" + process.env.VUE_APP_API_URL,
		baseUrl: "" + process.env.VUE_APP_BASE_URL,
		asOfDate: null,
		lang: "en",
		groups: [
    ],
		questions: [
    ],
		ageOnlyAnswers: [
    ],
		todos: [
    ]
	},
	getters,
	mutations,
	actions,
})